// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"af0f3cf1","80":"f523787f","106":"ea420836","240":"b5ac4fc5","346":"6e8ebb5f","488":"1c25583f","601":"92729dc9","874":"b2cdff14","963":"9cdca9d0"}[chunkId] + ".chunk.js";
};